import React, { useEffect } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import 'react-circular-progressbar/dist/styles.css';
import AOS from "aos";
import 'aos/dist/aos.css';
import './spec.css';

const colors = {
  primaryColor: "#ff6347",
};

const skills = [
  { skillName: "Javascript", value: 80, textColor: colors.primaryColor, pathColor: "#f9f871" },
  { skillName: "Python", value: 85, textColor: colors.primaryColor, pathColor: "#6e48ac" },
  { skillName: "Java", value: 90, textColor: colors.primaryColor, pathColor: "#111d5e" },
  { skillName: "MongoDB", value: 90, textColor: colors.primaryColor, pathColor: "#ff004f" },
  { skillName: "ExpreesJS", value: 80, textColor: colors.primaryColor, pathColor: "#00af91" },
  { skillName: "Solidity", value: 80, textColor: colors.primaryColor, pathColor: "#54e346" },
  { skillName: "C", value: 90, textColor: colors.primaryColor, pathColor: "#6e48ac" },
  { skillName: "HTML/CSS", value: 85, textColor: colors.primaryColor, pathColor: "#111d5e" },
  ];

const Specializing = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div className="container">
      <div className="card">
        <h1 className="text-center font-bold text-3xl mt-1">What I do</h1>
        <h2 className="text-center font-bold text-2xl mb-12">Specializing in</h2>
        <div data-aos="fade-up" className="skills-container">
          {skills.map((skill, index) => (
            <div key={index} className="skill">
              <h3>{skill.skillName}</h3>
              <div className="progress-bar-container">
                <CircularProgressbar
                  value={skill.value}
                  styles={buildStyles({
                    textColor: skill.textColor,
                    pathColor: skill.pathColor,
                  })}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Specializing;
